import { Badge } from "antd";
import { MoneyFormat } from "../../Components/MoneyFormat";

export const DEFUALT_COLUMNS = [
  "spec_concat",
  "card_no",
  "defect_no",
  "compliance_count",
  "raw_findings_rate",
  "total_effort_hours",
  "total_labor_cost_max",
  "yield_percentage",
  "mntc_check",
  "mntc_check_interval",
  "fec",
  "wpm_score",
  "rank",
  "status",
  "comments",
  "spec_type",
  "mntc_check_package",
  "mntc_check_package_interval",
  "assigned_to",
  "assigned_on",
];

export const keyLabelMap = {
  spec_concat: "Spec No.",
  card_no: "Card No.",
  defect_no: "Defect Count",
  compliance_count: "Compliance Count",
  raw_findings_rate: "Raw Finding Rate",
  total_effort_hours: "Total Effort Hours",
  total_labor_cost_max: "Approx. life-time labor Cost",
  yield_percentage: "Yield %",
  mntc_check: "Maintenance Check",
  mntc_check_interval: "Maintenance Check Interval",
  fec: "FEC",
  wpm_score: "Rank Score",
  rank: "Rank",
  spec_type: "Spec Type",
  mntc_check_package: "Maintenance Check Package",
  mntc_check_package_interval: "Maintenance Check Package Interval",
  status: "Status",
  assigned_to: "Assigned To",
};

export const rankingTableColumns = [
  {
    key: "sort",
  },
  {
    key: "spec_concat",
    width: "110px",
  },
  {
    key: "card_no",
    width: "130px",
  },
  {
    key: "raw_findings_rate",
    render: (ele) => {
      return ele.toFixed(3);
    },
  },
  {
    key: "total_labor_cost_max",
    render: (ele) => `${MoneyFormat(ele)}`,
  },
  {
    key: "yield_percentage",
    width: "130px",
  },
  {
    key: "mntc_check",
    width: "150px",
  },
  {
    key: "mntc_check_interval",
    width: "200px",
  },
  {
    key: "rank",
    align: "center",
  },
  {
    key: 'spec_type"',
    align: "center",
  },
  {
    width: "180px",
    key: "mntc_check_package",
  },
  {
    key: "mntc_check_package_interval",
    width: "220px",
  },
];

export const STSTUS_OPTION = [
  { value: null, label: "--select--" },
  { value: "Pending", label: <Badge status="processing" text="Pending" /> },
  {
    value: "Under Review",
    label: <Badge status="warning" text="Under Review" />,
  },
  {
    value: "Escalation Completed",
    label: <Badge status="success" text=" Completed" />,
  },
  { value: "Reject", label: <Badge status="error" text="Reject" /> },
  {
    value: "Fallout Tasks",
    label: <Badge status="default" text="Fallout Tasks" />,
  },
];

export const checkboxData = [
  { label: "Select All", value: "all" },
  { label: "Spec No.", value: "spec_concat" },
  { label: "Card No.", value: "card_no" },
  { label: "Defect Count", value: "defect_no" },
  { label: "Compliance Count", value: "compliance_count" },
  { label: "Raw Finding Rate", value: "raw_findings_rate" },
  { label: "Total Effort Hours", value: "total_effort_hours" },
  { label: "Approx. life-time labor Cost", value: "total_labor_cost_max" },
  { label: "Yield %", value: "yield_percentage" },
  { label: "Maintenance Check", value: "mntc_check" },
  { label: "Maintenance Check Interval", value: "mntc_check_interval" },
  { label: "FEC", value: "fec" },
  { label: "Rank Score", value: "wpm_score" },
  { label: "Rank", value: "rank" },
  { label: "Spec Type", value: "spec_type" },
  { label: "Maintenance Check Package", value: "mntc_check_package" },
  {
    label: "Maintenance Check Package Interval",
    value: "mntc_check_package_interval",
  },
  { label: "Status", value: "status" },
  { label: "Comments", value: "comments" },
  { label: "Assigned To", value: "assigned_to" },
];
export const REQUIRED_COLUMNS = [
  "spec_type",
  "card_no",
  "rank",
  "status",
  "assigned_to",
  "comments",
];

export const COMMENT_INITIAL_OBJECT = {
  userName: null,
  comments: "",
  errorFieds: {
    userName: "",
    comments: "",
  },
};

export const TSKLIST = [
  "CHECK/INSP",
  "CLN",
  "DET",
  "DIS",
  "DISINFECT",
  "FNC",
  "GVI",
  "INSP",
  "INST",
  "LUB",
  "OPC",
  "RESTORE",
  "ROUTE",
  "RST",
  "SAMP",
  "SDI",
  "SPT",
  "SVC",
  "VCK",
  "ZONAL (GV)",
  "N/A",
];

export const FILTER_INITIAL_OBJECT = {
  cat: "",
  status: [],
  task: [],
  specType: "",
  // yieldValue: 90,
  yieldValueFrom: 0,
  yieldValueTo: 100,
  maintenanceCheck: "",
  maintenanceCheckPackage: "",
  maintenanceCheckInterval: "",
  maintenanceCheckPackageInterval: "",
};

export const MOVE_RANK_INITIAL_OBJECT = {
  rank: "",
  errorFieds: {
    rank: "",
  },
};

export const COST_SAVINGS_MARKS = {
  0: "0%",
  10: "10",
  20: "20",
  30: "30",
  40: "40",
  50: "50",
  60: "60",
  70: "70",
  80: "80",
  90: "90",
  100: "100%",
};

export const COST_SAVINGS_INITIAL_OBJECT = {
  projectCost: "00",
  escalated_lab_ost: "",
  esculated_repeat_val: "",
  threshold_type: "",
  sliderValue: 0,
  yieldValue: [0, 100],
  expectedSavings: 0,
};

export const COST_SAVINGS_STYLES = {
  blueBox: {
    backgroundColor: "rgb(241, 243, 252)",
    padding: "0px 15px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    color: "#635858",
  },
  amountBox: {
    marginTop: "25px",
    padding: "10px 15px",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};
export const mntcCheck = [
  { label: "A-Check", value: "A-Check" },
  { label: "B-Check", value: "B-Check" },
  { label: "C-Check", value: "C-Check" },
  { label: "D-Check", value: "D-Check" },
  { label: "E-Check", value: "E-Check" },
  { label: "F-Check", value: "F-Check" },
];
export const mntcCheckPackage = [
  { label: "1C", value: "1C" },
  { label: "2C", value: "2C" },
  { label: "3C", value: "3C" },
  { label: "4C", value: "4C" },
  { label: "5C", value: "5C" },
];
export const mntcCheckInterval = [
  { label: "1 Month", value: "1 months" },
  { label: "2 Months", value: "2 months" },
  { label: "3 Months", value: "3 months" },
  { label: "4 Months", value: "4 months" },
  { label: "5 Months", value: "5 months" },
  { label: "6 Months", value: "6 months" },
  { label: "7 Months", value: "7 months" },
  { label: "8 Months", value: "8 months" },
  { label: "9 Months", value: "9 months" },
  { label: "10 Months", value: "10 months" },
  { label: "11 Months", value: "11 months" },
  { label: "12 Months", value: "12 months" },
  { label: "13 Months", value: "13 months" },
  { label: "14 Months", value: "14 months" },
  { label: "15 Months", value: "15 months" },
  { label: "16 Months", value: "16 months" },
  { label: "17 Months", value: "17 months" },
  { label: "18 Months", value: "18 months" },
  { label: "19 Months", value: "19 months" },
  { label: "20 Months", value: "20 months" },
  { label: "21 Months", value: "21 months" },
  { label: "22 Months", value: "22 months" },
  { label: "23 Months", value: "23 months" },
  { label: "24 Months", value: "24 months" },
  { label: "25 Months", value: "25 months" },
  { label: "26 Months", value: "26 months" },
];
export const mntcCheckPackageInterval = [
  { label: "1 Month", value: "1 months" },
  { label: "2 Months", value: "2 months" },
  { label: "3 Months", value: "3 months" },
  { label: "4 Months", value: "4 months" },
  { label: "5 Months", value: "5 months" },
  { label: "6 Months", value: "6 months" },
  { label: "7 Months", value: "7 months" },
  { label: "8 Months", value: "8 months" },
  { label: "9 Months", value: "9 months" },
  { label: "10 Months", value: "10 months" },
  { label: "11 Months", value: "11 months" },
  { label: "12 Months", value: "12 months" },
  { label: "13 Months", value: "13 months" },
  { label: "14 Months", value: "14 months" },
  { label: "15 Months", value: "15 months" },
  { label: "16 Months", value: "16 months" },
  { label: "17 Months", value: "17 months" },
  { label: "18 Months", value: "18 months" },
  { label: "19 Months", value: "19 months" },
  { label: "20 Months", value: "20 months" },
  { label: "21 Months", value: "21 months" },
  { label: "22 Months", value: "22 months" },
  { label: "23 Months", value: "23 months" },
  { label: "24 Months", value: "24 months" },
  { label: "25 Months", value: "25 months" },
  { label: "26 Months", value: "26 months" },
];
